import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IoChevronForward } from 'react-icons/io5';

import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Select, Option } from '@/components/ui/Select';
import { Toast } from '@/components/ui/Toast';
import { CONFIG } from '@/config';
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { Title } from "@/components/ui/Title.ts";
import {
  Container,
  Form,
  FormGroup,
  Label,
  FileUpload,
  FilePreview,
  PreviewImage,
  RemoveButton,
  ButtonGroup,
  DeleteButton
} from './styles/AddAssistantPage.styles';
import { assistantApi } from '@/api/assistants';
import { useNavigate, useParams } from 'react-router-dom';
import {scenarioApi} from "@/api/scenarios.ts";
import {Scenario} from "@/types/assistants.ts";

interface FormState {
  name: string;
  description: string;
  tg_token: string;
  picture_url: string | null;
  isUploading: boolean;
}

export const AddAssistantPage = () => {
  const [scenaries, setScenaries] = useState<Array<Scenario>>([]);
  const [scenario, setScenario] = useState<number | undefined>(undefined);
  const [name, setName] = useState<string>('');
  const [token, setToken] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm();
  const [formState, setFormState] = useState<FormState>({
    name: '',
    description: '',
    tg_token: '',
    picture_url: null,
    isUploading: false
  });
  console.log(formState);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success' as 'success' | 'error'
  });
  console.log(formState);

  useEffect(() => {
    if (id !== undefined) {
      assistantApi.getOne(parseInt(id)).then((res) => {
        setName(res.data.Name);
        setToken(res.data.Token);
        setFormState({
          name: res.data.Name,
          description: res.data.Description,
          tg_token: res.data.TgToken,
          picture_url: res.data.PictureURL,
          isUploading: false
        });
      });
      scenarioApi.getAll().then(({ data }: {data: Scenario[]}) => {
        const assistantScenario = data.filter(i => i.AssistantID === Number(id));
        setScenaries(assistantScenario)
        const defaultScenario = assistantScenario.find(i => i.IsDefault)
        if(defaultScenario) {
          setScenario(defaultScenario.ID)
        }
      })
    }
  }, [id]);

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setFormState(prev => ({ ...prev, isUploading: true }));

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${CONFIG.API_URL}/upload_handler`, {
        method: 'POST',
        body: formData
      });
      console.log(response);

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      const data = await response.json();
      console.log(data);
      setFormState(prev => ({ ...prev, picture_url: data.Url, isUploading: false }));
      setValue('picture_url', data.Url);

      setToast({
        show: true,
        message: 'File uploaded successfully',
        type: 'success'
      });
    } catch (error) {
      console.error(error)
      setToast({
        show: true,
        message: 'Failed to upload file',
        type: 'error'
      });
      setFormState(prev => ({ ...prev, isUploading: false }));
    }
  };

  const handleRemoveImage = () => {
    setFormState(prev => ({ ...prev, picture_url: null, isUploading: false }));
    setValue('picture_url', null);
  };

  const onSubmit = (data: any) => {
    const submitData = {
      ...data,
      picture_url: formState.picture_url,
      name: data.name || formState.name,
      description: data.description || formState.description,
      tg_token: data.tg_token || formState.tg_token,
      is_default: true
    };

    try {
      if (id !== undefined) {
        const selectedScenario = scenaries.find(i => i.ID === Number(data.scenario))
        submitData.id = parseInt(id);
        assistantApi.update(submitData).then(() => {
          scenarioApi.update({
            id: selectedScenario?.ID,
            name: selectedScenario?.Name,
            description: selectedScenario?.Description,
            is_default: true
          }).then(() => {
            navigate(`/dashboard/assistants`);
          })
        });
      } else {
        assistantApi.create(submitData).then(({ data }) => {
          scenarioApi.create({
            name: "Default",
            description: "",
            assistant_id: data.id,
            is_default: true,
          }).then(() => {
            navigate(`/dashboard/assistants`);
          })
        });
      }
    } catch (error) {
      console.error('Error creating assistant:', error);
    }
  };

  const handleDeleteAssistant = async () => {
    if (!id) return;

    try {
      await assistantApi.delete(parseInt(id));
      setToast({
        show: true,
        message: 'Ассистент успешно удален',
        type: 'success'
      });
      navigate('/dashboard/assistants');
    } catch (error) {
      console.error(error)
      setToast({
        show: true,
        message: 'Ошибка при удалении ассистента',
        type: 'error'
      });
    }
  };
  console.log(formState);

  return (
    <Container>
      {toast.show && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(prev => ({ ...prev, show: false }))}
        />
      )}

      <Title style={{ marginBottom: '1.2rem' }}>Мои ассистенты</Title>
      <Breadcrumbs>
        <a href="/dashboard/assistants">Мои ассистенты</a>
        <IoChevronForward size={14} color="#000000" />
        {id && (
            <>
              <a href={`/dashboard/assistants/${id}/scenarios`}>{name}</a>
              <IoChevronForward size={14} color="#000000"/>
            </>
        )}
        <span>{id ? 'Редактировать ассистента' : 'Добавить ассистента'}</span>
      </Breadcrumbs>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup>
          <Label>Наименование</Label>
          <Input
            {...register('name')}
            defaultValue={formState.name}
            placeholder="Наименование ассистента"
            width='410px'
            onChange={(e) => setFormState(prev => ({ ...prev, name: e.target.value }))}
          />
        </FormGroup>

        <FormGroup>
          <Label>Описание</Label>
          <Input
            {...register('description')}
            defaultValue={formState.description}
            placeholder="Описание ассистента"
            width='410px'
            onChange={(e) => setFormState(prev => ({ ...prev, description: e.target.value }))}
          />
        </FormGroup>

        <FormGroup>
          <Label>Telegram API Key</Label>
          <Input
            {...register('tg_token')}
            placeholder="43432974383279"
            width='410px'
            defaultValue={formState.tg_token}
            onChange={(e) => setFormState(prev => ({ ...prev, tg_token: e.target.value }))}
          />
        </FormGroup>

        <FormGroup>
          <Label>Языковая модель</Label>
          <Select width='410px' disabled>
            <Option value="chatgpt">ChatGPT</Option>
            <Option value="gpt4">GPT-4</Option>
          </Select>
        </FormGroup>

        {!id && (
            <FormGroup>
              <Label>Сценарий по умолчанию</Label>
              <Select
                  width='410px'
                  disabled
              >
                <Option value="Default">Default</Option>
              </Select>
            </FormGroup>
        )}
        {!!scenaries.length && (
            <FormGroup>
              <Label>Сценарий по умолчанию</Label>
              <Select
                  width='410px'
                  value={scenario}
                  {...register('scenario')}
                  onChange={(e) => setScenario(Number(e.target.value))}
              >
                {scenaries.map(i => (
                    <Option key={i.ID} value={i.ID}>{i.Name}</Option>
                ))}
              </Select>
            </FormGroup>
        )}

        <FormGroup>
          <Label>Изображение</Label>
          {!formState.picture_url ? (
            <FileUpload>
              <Button
                variant="primary"
                size="small"
                as="label"
                disabled={formState.isUploading}
              >
                {formState.isUploading ? 'Загрузка...' : 'Выбрать с диска'}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleFileUpload}
                />
              </Button>
            </FileUpload>
          ) : (
            <FilePreview>
              <PreviewImage>
                <img src={formState.picture_url} alt="" />
              </PreviewImage>
              <span>{formState.picture_url.split('/').pop()}</span>
              <RemoveButton onClick={handleRemoveImage}>
                Удалить
              </RemoveButton>
            </FilePreview>
          )}
        </FormGroup>
        {id && (
            <FormGroup>
              <Label>Код ассистена</Label>
              <pre style={{background: '#eee', borderRadius: '8px', width: '410px' }}>
                {`
                  <script
                      defer
                      src="https://widget.assistantlab.ru/widget.js"
                      data-token="${token}"
                      data-title="${name}"
                  ></script>
                `}
              </pre>
            </FormGroup>
        )}

        <ButtonGroup>
          <Button type="submit" variant="primary"
                  disabled={!formState.name || !formState.description}>Сохранить</Button>

          <DeleteButton disabled={id === undefined} type="button" onClick={handleDeleteAssistant}>Удалить
            ассистента</DeleteButton>
        </ButtonGroup>
      </Form>
    </Container>
  );
};
